<nav class="navbar navbar-light bg-light navbar-expand-lg">
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav">
            <li class="nav-item me-2">
                <div class="nav-item">
                    <input id="busquedaFormControl" type="text" class="form-control" placeholder="Nombre interfaz"
                    [formControl]="buscadorFormControl" (input)="filtrarInterfaces()"/>
                </div>
            </li>
        </ul>
    </div>
</nav>
<div class="row">
    <div class="col col-md-12">
        <div class="spinner-container" *ngIf="cargandoInterfaces">
          <ngx-spinner name="spinnerGrafico" bdOpacity=0.3bd
            Color="rgba(193,193,193,0)" size="medium" color="#185db5" type="ball-grid-beat" [fullScreen]="false">
            <p style="color: white">C a r g a n d o . . . </p>
          </ngx-spinner>
        </div>
    </div>
    
    <div class="col col-3">
        <div class="list-group py-3 mx-2 menu-izq">
            <app-interfaces-lista [interfaces]="interfacesFiltradas" [mensajeError]="mensajeError" (interfazSeleccionada)="mostrarInterfaz($event)"></app-interfaces-lista>
        </div>
    </div>
    <div class="col col-9 py-3">
        <app-interfaces-detalle *ngIf="interfazSeleccionada || error" [error]="error" [mensajeError]="mensajeError" [interfaz]="interfazSeleccionada"> </app-interfaces-detalle>
    </div>
</div>